const enTranslations = {
  language_label: "Language",
  vietnamese: "Vietnamese",
  chinese: "Chinese",
  english: "English",
  open_categories: "Open categories",
  search_placeholder: "Search by product, product code or brand...",
  customer_utilities: "Customer tools",
  account_fallback: "Account",
  logout_success: "Logged out successfully",
  logout_failed: "Unable to log out",
  generic_error_retry: "Something went wrong. Please try again later.",
  mobile_navigation: "Mobile navigation",
  support: "Support",
  back_to_top: "Back to top",
  shipping_policy: "Shipping & Delivery",
  privacy_policy: "Privacy Policy",
  shopping_guide: "Shopping Guide",
  warranty_request: "Warranty Request",
  send_support_request: "Send Support Request",
  technical_support_247: "24/7 Technical Support",
  hotline_label: "Hotline",
  breadcrumb: "Breadcrumb",
  brand_label: "Brand:",
  token_expired_login: "Your session has expired. Please log in again.",
  login_required_action: "Please log in to perform this action.",
  add_cart_success: "Product added to cart.",
  cart_status_updated: "Product status updated.",
  cart_cleared: "Cart cleared.",
  view_all: "View All",
  view_all_categories: "View All Categories",
  industrial_solutions: "TTSMART INDUSTRIAL SOLUTIONS",
  equipment_solutions: "Equipment solutions",
  for_concrete_mixing_stations: "for concrete mixing stations",
  genuine_quality: "Genuine Products · Reliable Quality",
  expert_technical_consulting: "Expert Technical Consultation",
  official_warranty: "Official Warranty",
  explore_now: "Explore Now",
  download_catalogue: "Download Catalogue",
  featured_categories: "Featured Categories",
  loading_products: "Loading products...",
  add_to_favorites: "Add to favorites",
  featured_brands: "Featured Brands",
  view_more: "View More",
  product_type_label: "Product type:",
  cluster_label: "Group:",
  equipment_label: "Equipment:",
  real_image_100: "100% Actual Product Images",
  return_by_policy: "Returns Subject to Policy",
  reviews_suffix: "reviews",
  sold_label: "Sold",
  vat_excluded: "VAT not included",
  buy_now: "Buy Now",
  call_now: "Call 0813.15.83.83",
  chat_zalo: "Chat on Zalo",
  hotline_number: "Hotline 0813.15.83.83",
  ttsmart_commitment: "TTSmart Commitments",
  nationwide_delivery: "Nationwide Delivery in Vietnam",
  related_products: "Related Products",
  product_info_updating: "Product information is being updated.",
  manual_label: "User Manual",
  datasheet_label: "Data Sheet",
  catalog_label: "Catalogue",
  chat: "Chat",
  call: "Call",
  contact_for_quote: "Request a Quote",
  customer_information: "Customer Information",
  policy_page_description: "Learn about TTSmart's purchasing, delivery, warranty and information protection policies.",
  loading_policy_content: "Loading policy content...",
  policy_categories: "Policy Categories",
  need_help: "Need help?",
  support_team_ready: "The TTSmart team is ready to assist you.",
  last_updated: "Last updated:",
  policy_contact_prompt: "If you have any questions about this policy, please contact us for support.",
  contact_now: "Contact Us",
  policy_load_error: "Unable to load policy content. Please try again later.",
  loading_station_data: "Loading station data...",
  login_required_title: "Login Required",
  login_required_station_desc: "Please log in with your customer account to view your assigned stations.",
  assigned_stations_desc: "View and manage the stations assigned to your account.",
  total_stations: "Total Stations",
  active_stations: "Active Stations",
  active_station: "Active",
  maintenance_station: "Under Maintenance",
  stopped_station: "Inactive",
  assigned_station_list: "Assigned Stations",
  search_stations: "Search stations...",
  list_view: "List",
  grid_view: "Grid",
  no_matching_stations: "No matching stations found.",
  actions: "Actions",
  active: "Active",
  code_label: "Code:",
  showing: "Showing",
  of: "of",
  stations_unit: "stations",
  devices_unit: "devices",
  per_page: "/ page",
  item_label: "Item",
  button_count: "Button count",
  rows_per_page_10: "10 rows per page",
  view_details: "View Details",
  microphone_secure_required: "Your browser requires HTTPS or localhost to use the microphone.",
  speak_longer: "Please speak a little longer before stopping.",
  listening_instructions: "Listening... Click the microphone again when you are finished.",
  microphone_permission_error: "Unable to access the microphone. Please grant microphone permission for this website.",
  processing_voice: "Processing voice input...",
  search_text_required: "Please enter a search query.",
  processing_search: "Processing your search...",
  voice_search_placeholder: "Enter a query, for example: find TTSM1 pneumatic solenoid valve",
  switch_to_text_input: "Switch to keyboard input",
  switch_to_voice_input: "Switch to voice search",
  auto_login_success: "Automatic login successful!",
  auto_logging_in: "Signing you in automatically...",
  image_heading: "Image",
  display_range: "Showing",
  page_size_10: "10 / page",
  page_size_20: "20 / page",
  page_size_50: "50 / page",
  policy_purchase_title: "Purchase Policy",
  policy_warranty_title: "Warranty & Returns",
  policy_shipping_title: "Shipping & Delivery",
  policy_privacy_title: "Privacy Policy",
  policy_purchase_short: "Purchasing",
  policy_warranty_short: "Warranty & Returns",
  policy_shipping_short: "Shipping",
  policy_privacy_short: "Privacy",
  unknown: "Unknown",
  stock_quantity: "Stock",
  add_product_to_cart: "Add product to cart",
  search_result_prefix: "Search",
  audio_parse_failed: "Unable to interpret the audio.",
  voice_process_error: "An error occurred while processing the voice input.",
  text_parse_failed: "Unable to interpret the search query.",
  search_process_error: "An error occurred while processing the search query.",
  close_text_input: "Close text input",
  keyboard_search: "Enter a search query with the keyboard",
  stop_and_search: "Click again to stop and search",
  start_voice_search: "Click to start voice search",
  auto_login_missing_code: "No login code was provided.",
  auto_login_failed: "Automatic login failed.",
  auto_login_error: "An error occurred during automatic login.",
  product_display_range: "Showing {first}–{last} of {total} products",
  product_code_label: "Product code",
  manufacturer_label: "Manufacturer",
  product_type_summary_label: "Product type",
  color_label: "Color",
  shape_label: "Shape",
  frame_label: "Frame",
  in_stock: "In stock",
  remaining_products: "{count} products remaining",
  pdf_document: "PDF document",
  technical_document: "Technical document",
  remove_from_cart: "Remove from cart",
  product_categories: "Product Categories",
  best_selling_products: "Best-selling Products",
  genuine_products: "Genuine Products",
  genuine_commitment: "100% Genuine Product Commitment",
  trusted_warranty: "Reliable Warranty",
  fast_on_time_delivery: "Fast, On-time Delivery",
  support_247: "24/7 Support",
  free_technical_consulting: "Free Technical Consultation",
  category: "Category",
  unknown_error: "An unknown error occurred.",
  percent_of_total_stations: "{percent}% of all stations",
  station_image: "Station Image",
  station_name: "Station Name",
  station_code: "Station Code",
  product_count: "Product Count",
  location: "Location",
  station_display_range: "Showing {first}–{last} of {total} stations",
  device_display_range: "Showing {first}–{last} of {total} devices",
  station_not_found: "Station not found.",
  updating_status: "Updating",
  introduction_empty: "No introduction content is available yet.",
  loading_introduction: "Loading introduction...",
  introduction_load_error: "Unable to load the introduction. Please try again later.",
  error_occurred: "An error occurred",
  password_strength_weak: "Weak",
  password_strength_medium: "Medium",
  password_strength_good: "Good",
  password_strength_strong: "Strong",
  fill_all_fields: "Please complete all fields",
  password_minimum_length: "The password must contain at least 6 characters",
  change_password_failed: "Unable to change the password",
  change_password_success: "Password changed successfully",
  server_error: "Server error. Please try again later",
  change_password_description: "Create a new password to keep your account secure.",
  current_password_placeholder: "Enter your current password",
  toggle_password_visibility: "Show or hide password",
  new_password_placeholder: "Enter a new password",
  password_strength: "Password strength",
  password_rule_note: "Use at least 6 characters; a mix of uppercase and lowercase letters, numbers, and special characters is recommended.",
  confirm_password_placeholder: "Re-enter the new password",
  encrypted_security_note: "Your information is encrypted and securely protected.",
  copied: "Order number copied",
  copy_failed: "Unable to copy the order number",
  other_products: "other products",
  orders_description: "Track the processing, delivery, and payment status of your orders.",
  order_status: "Order Status",
  loading_orders: "Loading orders...",
  unable_to_load_orders: "Unable to load orders",
  try_again: "Try Again",
  empty_orders_hint: "No orders match the selected status.",
  continue_shopping: "Continue Shopping",
  copy_order_code: "Copy order number",
  construction: "Project Site",
  full_name_required: "Please enter your full name",
  account_info_description: "Manage your contact information and delivery addresses.",
  personal_info_hint: "Information used to contact you and confirm orders",
  edit: "Edit",
  account_security: "Account Security",
  change_password_regularly: "Change your password regularly to protect your account.",
  address_book_hint: "Save addresses for faster checkout",
  no_saved_address_title: "No delivery addresses saved",
  add_new_address: "Add New Address",
  set_default: "Set as Default",
  default: "Default",
  delete: "Delete",
  my_addresses: "My Addresses",
  my_account: "My Account",
  customer_support_247: "24/7 Customer Support",
  contact_price: "Contact for Price",
  product_image_alt: "Product image",
  product_no_longer_exists: "This product is no longer available",
  register_failed: "Unable to register the account. The email address or phone number may already be in use.",
  otp_send_failed: "Unable to send the OTP. Please check your information and try again.",
  reset_password_failed: "Unable to reset the password. The OTP may be incorrect or expired.",
  order_creation_failed: "Unable to create the order. Please review your cart and try again.",
};

export default enTranslations;
